// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import Select from "react-select";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import AuthContext from "../context/AuthContext";
// import { apiGet } from "../Utils/apiFetch";
// import { apiPath } from "../Utils/apiPath";
// import { compact, filter, isEmpty, lowerCase, startCase } from "lodash";
// import {
//   DownlineHeader,
//   layerPanel1,
//   LayerUserNumber,
//   LayerUserText,
//   toFixedWithoutRounding,
//   user_next_status,
// } from "../Utils/Constant";
// import AddUserModal from "./User/AddUser";
// import { useContextSelector } from "use-context-selector";
// import UserList from "./User/UserList";

// const Home = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const user = useContextSelector(AuthContext, (ctx) => {
//     return ctx.user;
//   });

//   const { layer, "*": splat } = useParams();

//   const downlineList = DownlineHeader(user?.userType)[0];

//   const [results, setResults] = useState([]);
//   const [show, setShow] = useState(false);

//   // compute this the SAME way both places use it
//   const initialUserType =
//     user?.userType == "agent"
//       ? "user"
//       : !isEmpty(layer)
//         ? LayerUserNumber[layer]
//         : downlineList?.key;
//   const getLastSegment = (splat) => {
//     const parts = splat ? splat.split("/") : [];
//     if (parts.length < 2) return null;

//     const userType = parts[parts.length - 2];
//     const id = parts[parts.length - 1];

//     return { userType, id };
//   };

//   const handleDrillDown = (row) => {
//     return `${location.pathname}/${user_next_status[row?.userType]}/${row?._id}`;
//   };

//   const [search_params, setSearchParams] = useState({
//     page: 1,
//     limit: 20,
//     keyword: "",
//     status: "active",
//     created_by: user?._id,
//     userType: initialUserType, // ✅ correct from the very first render
//     sortBy: "",
//     orderBy: "asc",
//   });
//   const [balance, setBalance] = useState({
//     totalAvailableLimit: 0,
//     totalAmount: 0,
//     totalCoins: 0,
//     playerBalance: 0,
//     availableLimit: 0,
//     exposure: 0,
//     creditReference: 0,
//     playerCounts: 0,
//     creditReferences:0
//   });
//   const [message, setMessage] = useState([]);

//   const handleSort = useCallback((key) => {
//     setSearchParams((prevState) => {
//       if (prevState.sortBy === key) {
//         return {
//           ...prevState,
//           orderBy: prevState.orderBy === "asc" ? "desc" : "asc",
//         };
//       }
//       return { ...prevState, sortBy: key, orderBy: "asc", page: 1 };
//     });
//   }, []);

//   const onSubmit = useCallback((params) => {
//     setSearchParams((prevState) => ({
//       ...prevState,
//       page: 1,
//       keyword: params.keyword,
//       status: params.status,
//     }));
//   }, []);

//   const handlePageClick = useCallback((event) => {
//     setSearchParams((prevState) => ({
//       ...prevState,
//       page: event.selected + 1,
//     }));
//   }, []);
//   const handleStatusChange = useCallback((selected) => {
//     setSearchParams((prevState) => ({
//       ...prevState,
//       page: 1,
//       status: selected ? selected.value : "all",
//     }));
//   }, []);
//   const getUsers = useCallback(
//     async (obj, config = {}) => {
//       const { status, data: response_users } = await apiGet(
//         apiPath.downLineList,
//         !isEmpty(obj)
//           ? { ...obj, status: lowerCase(obj?.status) }
//           : { ...search_params, status: lowerCase(search_params?.status) },
//         config,
//       );
//       if (status === 200 && response_users.success) {
//         setResults(response_users?.results || []);

//         const totals = response_users?.results?.data.reduce(
//             (acc, u) => {
//               const balance =
//                 u?.userType === "user"
//                   ? toFixedWithoutRounding(
//                       (u?.totalCoins1 || 0) + Math.abs(u?.exposure || 0),
//                       2,
//                     )
//                   : toFixedWithoutRounding(u?.totalCoins || 0, 2);
//               const newTotalUser =
//                 u?.totalCoins1 + Math.abs(u?.exposure) <= 0
//                   ? 0
//                   : u?.totalCoins1 + Math.abs(u?.exposure);

//               acc.balance += Number(balance) || 0;

//               acc.refPL += u.creditReference > 0 ? u.creditReference - balance : 0;

//               return acc;
//             },
//             { refPL: 0 },
//           );

//         if ("balance" in response_users?.results) {
//           const balance_info = response_users.results.balance;
//           setBalance((prevState) => ({
//             ...prevState,
//             totalAvailableLimit: balance_info.totalAvailableLimit,
//             totalAmount: balance_info.totalAmount,
//             totalCoins: balance_info.totalCoins,
//             playerBalance: balance_info.playerBalance,
//             availableLimit: balance_info.availableLimit,
//             exposure: balance_info.exposure,
//             playerExposure: balance_info.playerExposure,
//             creditReference: balance_info.creditReference,
//             playerCounts: balance_info.playerCounts,
//             creditReferences:balance_info.creditReferences,
//             refPL:totals?.refPL
//           }));
//         }
//       }
//     },
//     [search_params],
//   );

//   const handlePageChange = (newPage) => {
//     setSearchParams((prev) => ({ ...prev, page: newPage }));
//     getUsers();
//   };

//   useEffect(() => {
//     setSearchParams((prevState) => ({
//       ...prevState,
//       page: 1,
//       page_size: 10,
//       keyword: "",
//       status: "active",
//       created_by: !isEmpty(splat) ? getLastSegment(splat)?.id : user?._id,
//       userType: !isEmpty(splat)
//         ? getLastSegment(splat)?.userType
//         : initialUserType,
//     }));
//   }, [layer, splat]);

//   useEffect(() => {
//     getUsers();
//   }, [
//     search_params?.page,
//     search_params?.keyword,
//     search_params?.status,
//     search_params?.created_by,
//     search_params?.userType,
//     search_params?.sortBy,
//     search_params?.orderBy,
//   ]);

//   const messageList = useCallback(async () => {
//     let hostname = window.location.hostname
//       .replace(/^www\./, "")
//       .replace(/^ag\./, "");
//     hostname = hostname || "sabaexch.com";
//     const { status, data: response_users } = await apiGet(
//       apiPath.messageList + "&domain=" + hostname,
//     );
//     if (status === 200 && response_users.success) {
//       setMessage(response_users.results);
//     }
//   }, []);

//   useEffect(() => {
//     messageList();
//   }, []);

//   // useEffect(() => {
//   //   const intervalID = setInterval(
//   //     () => getUsers(search_params, { skipLoader: true }),
//   //     10 * 1000,
//   //   );
//   //   return () => clearInterval(intervalID);
//   // }, [search_params, getUsers]);

//   const availableBalance = useMemo(
//     () =>
//       (balance?.totalAmount &&
//         Math.abs(balance?.totalAmount) - Math.abs(balance?.playerExposure)) ||
//       0,
//     [balance?.totalAmount, balance?.playerExposure],
//   );

//   const canAddUser = isEmpty(splat);

//   return (
//     <app-users-list _nghost-serverapp-c112 className="ng-star-inserted">
//       <div _ngcontent-serverapp-c112 className="main_wrap">
//         <div _ngcontent-serverapp-c112 className="marquee-box">
//           <h4 _ngcontent-serverapp-c112>News</h4>
//           <div _ngcontent-serverapp-c112 className="marquee">
//             <div _ngcontent-serverapp-c112 className="marquee-content">
//               {message.map((res) => {
//                 return (
//                   <span
//                     _ngcontent-serverapp-c112
//                     className="ticker-item ng-star-inserted"
//                   >
//                     {res.title} - {res.message}
//                   </span>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div _ngcontent-serverapp-c112 className="main_wrap">
//         <div _ngcontent-serverapp-c112 className="total_all">
//           <div _ngcontent-serverapp-c112 className="agent_path">
//             <div
//               _ngcontent-serverapp-c112
//               id="userSearchUl"
//               className="search-wrap ng-star-inserted"
//             >
//               <input
//                 _ngcontent-serverapp-c112
//                 appinputrestriction="noSpecialChars"
//                 type="text"
//                 name="userId"
//                 value={search_params?.keyword}
//                 id="userId"
//                 onChange={(e) => {
//                   setSearchParams((prev) => {
//                     return { ...prev, keyword: e.target.value };
//                   });
//                 }}
//                 className="search-input ng-untouched ng-valid ng-dirty"
//                 placeholder="Find member..."
//               />
//               <button
//                 onClick={() => onSubmit}
//                 _ngcontent-serverapp-c112
//                 id="searchUserId"
//                 className="search-but"
//               >
//                 Search
//               </button>
//             </div>
//           </div>
//         </div>
//         <router-outlet _ngcontent-serverapp-c112 />
//         <app-children className="ng-star-inserted">
//           <router-outlet />
//           <app-sub _nghost-serverapp-c111 className="ng-star-inserted">
//             <div _ngcontent-serverapp-c111 className="total_all">
//               <Select
//                 options={eventOptions}
//                 placeholder="Select Status"
//                 isSearchable
//                 isClearable
//                 className="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-pristine ng-valid ng-select-bottom ng-touched"
//                 classNamePrefix="ng"
//                 value={
//                   eventOptions.find(
//                     (o) =>
//                       lowerCase(o.value) === lowerCase(search_params.status),
//                   ) || eventOptions[0]
//                 }
//                 onChange={handleStatusChange}
//               />

//               <span _ngcontent-serverapp-c111 className="spacer" />

//               {canAddUser && (
//                 <button
//                   onClick={() => setShow(true)}
//                   className="add_member btn ng-star-inserted"
//                 >
//                   <img src="/assets/images/transparent.gif" alt="" />
//                   Add{" "}
//                   {user?.userType == "agent"
//                     ? "User"
//                     : startCase(LayerUserText[layer])}
//                 </button>
//               )}

//               <button
//                 onClick={() => getUsers()}
//                 _ngcontent-serverapp-c111
//                 id="refresh"
//                 className="btn_replay btn"
//                 style={{ marginRight: "5px" }}
//               >
//                 <img
//                   _ngcontent-serverapp-c111
//                   src="/assets/images/transparent.gif"
//                 />
//               </button>
//             </div>
//             <div _ngcontent-serverapp-c111 style={{ display: "flex" }}>
//               <div
//                 _ngcontent-serverapp-c111
//                 style={{
//                   "-webkit-box-pack": "start",
//                   "-webkit-justify-content": "flex-start",
//                   "-ms-flex-pack": "start",
//                   "justify-content": "flex-start",
//                 }}
//               />
//             </div>
//             <div
//               style={{ padding: "7px 10px 5px" }}
//               _ngcontent-serverapp-c111
//               id="totalBox"
//               className="total_box filtertotaldivweb"
//             >
//               <dl
//                 _ngcontent-serverapp-c111
//                 id="creditLimitDL"
//                 className="total_dl ng-star-inserted"
//               >
//                 <dt _ngcontent-serverapp-c111> Total Balance</dt>
//                 <dd _ngcontent-serverapp-c111 id="myCreditLimit">
//                   {" "}
//                   USD
//                   <span _ngcontent-serverapp-c111 className="ng-star-inserted">
//                     {" "}
//                     {toFixedWithoutRounding(balance?.totalAmount)}
//                   </span>
//                 </dd>
//               </dl>

//               <dl
//                 _ngcontent-serverapp-c111
//                 id="totalExposureDL"
//                 className="total_dl"
//               >
//                 <dt _ngcontent-serverapp-c111>Net Exposure</dt>
//                 <dd _ngcontent-serverapp-c111 id="totalExposure">
//                   {" "}
//                   USD
//                   <span
//                     style={{ marginLeft: "5px" }}
//                     _ngcontent-serverapp-c111
//                     className="red"
//                   >
//                     ({toFixedWithoutRounding(balance?.playerExposure)})
//                   </span>
//                 </dd>
//               </dl>

//               <dl
//                 _ngcontent-serverapp-c111
//                 id="balanceDownline"
//                 className="total_dl"
//               >
//                 <dt _ngcontent-serverapp-c111>Balance</dt>
//                 <dd _ngcontent-serverapp-c111 id="myCreditLimit">
//                   {" "}
//                   USD
//                   <span _ngcontent-serverapp-c111 className="ng-star-inserted">
//                     {" "}
//                     {toFixedWithoutRounding(balance?.totalCoins)}
//                   </span>
//                 </dd>
//               </dl>
//               <dl
//                 _ngcontent-serverapp-c111
//                 id="availableBalanceDL"
//                 className="total_dl"
//               >
//                 <dt _ngcontent-serverapp-c111>Balance in Downline</dt>
//                 <dd _ngcontent-serverapp-c111 id="totalAvailBal">
//                   {" "}
//                   USD
//                   <span _ngcontent-serverapp-c111 className="ng-star-inserted">
//                     {" "}
//                    {toFixedWithoutRounding(balance?.playerBalance)}
//                   </span>
//                 </dd>
//               </dl>
//               <dl
//                 _ngcontent-serverapp-c111
//                 id="availableBalanceDL"
//                 className="total_dl"
//               >
//                 <dt _ngcontent-serverapp-c111>Transferable P/L with Upline</dt>
//                 <dd _ngcontent-serverapp-c111 id="totalAvailBal">
//                   {" "}
//                   USD{" "}
//                   <span className="red">
//                     ({toFixedWithoutRounding(balance?.refPL)})
//                   </span>
//                 </dd>
//               </dl>

//               <dl
//                 _ngcontent-serverapp-c111
//                 className="total_dl ng-star-inserted"
//               >
//                 <dt _ngcontent-serverapp-c111>Total Users</dt>
//                 <dd _ngcontent-serverapp-c111>
//                   {" "}
//                   {toFixedWithoutRounding(results?.totalDocs)}{" "}
//                 </dd>
//               </dl>
//             </div>
//             <div
//               _ngcontent-serverapp-c111
//               id="totalBox"
//               className="total_box filtertotaldivmob ng-star-inserted"
//             >
//               <dl
//                 _ngcontent-serverapp-c111
//                 id="creditLimitDL"
//                 className="total_dl_mob"
//               >
//                 <dt _ngcontent-serverapp-c111>Total Player Balance</dt>
//                 <dd
//                   _ngcontent-serverapp-c111
//                   id="myCreditLimit"
//                   className="push"
//                 >
//                   <strong _ngcontent-serverapp-c111>
//                     {" "}
//                     {toFixedWithoutRounding(balance?.playerBalance)}
//                   </strong>{" "}
//                   (USD){" "}
//                 </dd>
//               </dl>

//               <div _ngcontent-serverapp-c111 className="text-center">
//                 <span _ngcontent-serverapp-c111 id="user">
//                   <i _ngcontent-serverapp-c111 className="fa fa-chevron-down" />
//                 </span>
//               </div>
//             </div>
//             {/* user_next_status */}
//             <UserList
//               results={results}
//               handlePageClick={handlePageClick}
//               getUsers={getUsers}
//               data={user.userType}
//               sortBy={search_params?.sortBy}
//               orderBy={search_params?.orderBy}
//               handleSort={handleSort}
//               handlePageChange={handlePageChange}
//               handleDrillDown={(row) => handleDrillDown(row)}
//             />
//             <div
//               _ngcontent-serverapp-c111
//               className="footer_info ng-star-inserted"
//             >
//               <div _ngcontent-serverapp-c111 className="main_wrap">
//                 <ul _ngcontent-serverapp-c111 className="action">
//                   <li _ngcontent-serverapp-c111 className="f-tab">
//                     <span _ngcontent-serverapp-c111 className="timeuserlock">
//                       F
//                     </span>
//                     <p
//                       _ngcontent-serverapp-c111
//                       className="data_line data-text"
//                     >
//                       User Locked{" "}
//                     </p>
//                   </li>

//                   <li
//                     _ngcontent-serverapp-c111
//                     className="lock 111 ng-star-inserted"
//                   >
//                     <p
//                       _ngcontent-serverapp-c111
//                       className="data_line data-text1"
//                     >
//                       Block Market{" "}
//                     </p>
//                   </li>

//                   <li _ngcontent-serverapp-c111 className="p_l">
//                     <p
//                       _ngcontent-serverapp-c111
//                       className="data_line data-text1"
//                     >
//                       Betting Profit Loss{" "}
//                     </p>
//                   </li>
//                   <li _ngcontent-serverapp-c111 className="betting_history">
//                     <p
//                       _ngcontent-serverapp-c111
//                       className="data_line data-text1"
//                     >
//                       Betting History{" "}
//                     </p>
//                   </li>
//                   <li _ngcontent-serverapp-c111 className="profile">
//                     <p
//                       _ngcontent-serverapp-c111
//                       className="data_line data-text1"
//                     >
//                       Profile{" "}
//                     </p>
//                   </li>
//                   <li _ngcontent-serverapp-c111 className="status">
//                     <p
//                       _ngcontent-serverapp-c111
//                       className="data_line data-text1"
//                     >
//                       Change status{" "}
//                     </p>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </app-sub>
//         </app-children>
//       </div>

//       <AddUserModal
//         isOpen={show}
//         title={`Add ${user?.userType == "agent" ? "User" : startCase(LayerUserText[layer])}`}
//         id={user._id}
//         slug={user?.userType == "agent" ? "user" : initialUserType}
//         submitText="Create"
//         onClose={() => setShow(false)}
//         refreshUsers={getUsers}
//       />
//     </app-users-list>
//   );
// };

// export default Home;

// const eventOptions = [
//   { value: "active", label: "Active" },
//   { value: "Locked", label: "Locked" },
//   { value: "Suspend", label: "Suspend" },
// ];

// const ADMIN_ROLES = ["super_admin", "sub_owner", "owner"];

import React, { useEffect, useState, useCallback, useMemo } from "react";
import Select from "react-select";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { apiGet } from "../Utils/apiFetch";
import { apiPath } from "../Utils/apiPath";
import { compact, filter, isEmpty, lowerCase, startCase } from "lodash";
import {
  DownlineHeader,
  layerPanel1,
  LayerUserNumber,
  LayerUserText,
  toFixedWithoutRounding,
  user_next_status,
} from "../Utils/Constant";
import AddUserModal from "./User/AddUser";
import { useContextSelector } from "use-context-selector";
import UserList from "./User/UserList";

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });

  const { layer, "*": splat } = useParams();

  const downlineList = DownlineHeader(user?.userType)[0];

  const [results, setResults] = useState([]);
  const [show, setShow] = useState(false);

  // compute this the SAME way both places use it
  const initialUserType =
    user?.userType == "agent"
      ? "user"
      : !isEmpty(layer)
        ? LayerUserNumber[layer]
        : downlineList?.key;
  const getLastSegment = (splat) => {
    const parts = splat ? splat.split("/") : [];
    if (parts.length < 2) return null;

    const userType = parts[parts.length - 2];
    const id = parts[parts.length - 1];

    return { userType, id };
  };

  const handleDrillDown = (row) => {
    return `${location.pathname}/${user_next_status[row?.userType]}/${row?._id}`;
  };

  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 10,
    keyword: "",
    status: "active",
    created_by: user?._id,
    userType: initialUserType, // ✅ correct from the very first render
    sortBy: "",
    orderBy: "asc",
  });
  const [balance, setBalance] = useState({
    totalAvailableLimit: 0,
    totalAmount: 0,
    totalCoins: 0,
    playerBalance: 0,
    availableLimit: 0,
    exposure: 0,
    creditReference: 0,
    playerCounts: 0,
    creditReferences: 0,
  });
  const [message, setMessage] = useState([]);

  const handleSort = useCallback((key) => {
    setSearchParams((prevState) => {
      if (prevState.sortBy === key) {
        return {
          ...prevState,
          orderBy: prevState.orderBy === "asc" ? "desc" : "asc",
        };
      }
      return { ...prevState, sortBy: key, orderBy: "asc", page: 1 };
    });
  }, []);

  const onSubmit = useCallback((params) => {
    setSearchParams((prevState) => ({
      ...prevState,
      page: 1,
      keyword: params.keyword,
      status: params.status,
    }));
  }, []);

  const handlePageClick = useCallback((event) => {
    setSearchParams((prevState) => ({
      ...prevState,
      page: event.selected + 1,
    }));
  }, []);
  const handleStatusChange = useCallback((selected) => {
    setSearchParams((prevState) => ({
      ...prevState,
      page: 1,
      status: selected ? selected.value : "all",
    }));
  }, []);
  const getUsers = useCallback(
    async (obj, config = {}) => {
      const { status, data: response_users } = await apiGet(
        apiPath.newdownLineList,
        !isEmpty(obj)
          ? { ...obj, status: lowerCase(obj?.status) }
          : { ...search_params, status: lowerCase(search_params?.status) },
        config,
      );
      if (status === 200 && response_users.success) {
        setResults(response_users?.results || []);

        const totals = response_users?.results?.data.reduce(
          (acc, u) => {
            const balance =
              u?.userType === "user"
                ? toFixedWithoutRounding(
                    (u?.totalCoins1 || 0) + Math.abs(u?.exposure || 0),
                    2,
                  )
                : toFixedWithoutRounding(u?.totalCoins || 0, 2);

            const totalbalance =
              u?.userType === "user"
                ? toFixedWithoutRounding(
                    (u?.totalCoins1 || 0) + Math.abs(u?.exposure || 0),
                    2,
                  )
                : toFixedWithoutRounding(u?.totalCoins1 || 0, 2);

            acc.balance += Number(balance) || 0;

            acc.refPL +=
              u.creditReference > 0 ? u.creditReference - totalbalance : 0;

            return acc;
          },
          { refPL: 0 },
        );

        if ("balance" in response_users?.results) {
          const balance_info = response_users.results.balance;
          setBalance((prevState) => ({
            ...prevState,
            totalAvailableLimit: balance_info.totalAvailableLimit,
            totalAmount: balance_info.totalAmount,
            totalCoins: balance_info.totalCoins,
            playerBalance: balance_info.playerBalance,
            availableLimit: balance_info.availableLimit,
            exposure: balance_info.exposure,
            playerExposure: balance_info.playerExposure,
            creditReference: balance_info.creditReference,
            playerCounts: balance_info.playerCounts,
            creditReferences: balance_info.creditReferences,
            totalBalance: balance_info.totalBalance,
            refPL: balance_info?.creditReferences,
            totalAvailableBalance:balance_info?.totalAvailableBalance,
            totalCreditReference:balance_info?.totalCreditReference,
          }));
        }
      }
    },
    [search_params],
  );

  const handlePageChange = (newPage) => {
    setSearchParams((prev) => ({ ...prev, page: newPage }));
    // getUsers();
  };

  useEffect(() => {
    setSearchParams((prevState) => ({
      ...prevState,
      page: 1,
      page_size: 10,
      keyword: "",
      status: "active",
      created_by: !isEmpty(splat) ? getLastSegment(splat)?.id : user?._id,
      userType: !isEmpty(splat)
        ? getLastSegment(splat)?.userType
        : initialUserType,
    }));
  }, [layer, splat]);

  useEffect(() => {
    getUsers();
  }, [
    search_params?.page,
    search_params?.keyword,
    search_params?.status,
    search_params?.created_by,
    search_params?.userType,
    search_params?.sortBy,
    search_params?.orderBy,
  ]);

  const messageList = useCallback(async () => {
    let hostname = window.location.hostname
      .replace(/^www\./, "")
      .replace(/^ag\./, "");
    hostname = hostname || "sabaexch.com";
    const { status, data: response_users } = await apiGet(
      apiPath.messageList + "&domain=" + hostname,
    );
    if (status === 200 && response_users.success) {
      setMessage(response_users.results);
    }
  }, []);

  useEffect(() => {
    messageList();
  }, []);

  const canAddUser = isEmpty(splat);

  return (
    <app-users-list _nghost-serverapp-c112 className="ng-star-inserted">
      <div _ngcontent-serverapp-c112 className="main_wrap">
        <div _ngcontent-serverapp-c112 className="marquee-box">
          <h4 _ngcontent-serverapp-c112>News</h4>
          <div _ngcontent-serverapp-c112 className="marquee">
            <div _ngcontent-serverapp-c112 className="marquee-content">
              {message.map((res) => {
                return (
                  <span
                    _ngcontent-serverapp-c112
                    className="ticker-item ng-star-inserted"
                  >
                    {res.title} - {res.message}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div _ngcontent-serverapp-c112 className="main_wrap">
        <div _ngcontent-serverapp-c112 className="total_all">
          <div _ngcontent-serverapp-c112 className="agent_path">
            <div
              _ngcontent-serverapp-c112
              id="userSearchUl"
              className="search-wrap ng-star-inserted"
            >
              <input
                _ngcontent-serverapp-c112
                appinputrestriction="noSpecialChars"
                type="text"
                name="userId"
                value={search_params?.keyword}
                id="userId"
                onChange={(e) => {
                  setSearchParams((prev) => {
                    return { ...prev, keyword: e.target.value };
                  });
                }}
                className="search-input ng-untouched ng-valid ng-dirty"
                placeholder="Find member..."
              />
              <button
                onClick={() => onSubmit}
                _ngcontent-serverapp-c112
                id="searchUserId"
                className="search-but"
              >
                Search
              </button>
            </div>
          </div>
        </div>
        <router-outlet _ngcontent-serverapp-c112 />
        <app-children className="ng-star-inserted">
          <router-outlet />
          <app-sub _nghost-serverapp-c111 className="ng-star-inserted">
            <div _ngcontent-serverapp-c111 className="total_all">
              <Select
                options={eventOptions}
                placeholder="Select Status"
                isSearchable
                isClearable
                className="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-pristine ng-valid ng-select-bottom ng-touched"
                classNamePrefix="ng"
                value={
                  eventOptions.find(
                    (o) =>
                      lowerCase(o.value) === lowerCase(search_params.status),
                  ) || eventOptions[0]
                }
                onChange={handleStatusChange}
              />

              <span _ngcontent-serverapp-c111 className="spacer" />

              {canAddUser && (
                <button
                  onClick={() => setShow(true)}
                  className="add_member btn ng-star-inserted"
                >
                  <img src="/assets/images/transparent.gif" alt="" />
                  Add{" "}
                  {user?.userType == "agent"
                    ? "User"
                    : startCase(LayerUserText[layer])}
                </button>
              )}

              <button
                onClick={() => getUsers()}
                _ngcontent-serverapp-c111
                id="refresh"
                className="btn_replay btn"
                style={{ marginRight: "5px" }}
              >
                <img
                  _ngcontent-serverapp-c111
                  src="/assets/images/transparent.gif"
                />
              </button>
            </div>
            <div _ngcontent-serverapp-c111 style={{ display: "flex" }}>
              <div
                _ngcontent-serverapp-c111
                style={{
                  "-webkit-box-pack": "start",
                  "-webkit-justify-content": "flex-start",
                  "-ms-flex-pack": "start",
                  "justify-content": "flex-start",
                }}
              />
            </div>
            <div
              style={{ padding: "7px 10px 5px" }}
              _ngcontent-serverapp-c111
              id="totalBox"
              className="total_box filtertotaldivweb"
            >
              <dl
                _ngcontent-serverapp-c111
                id="creditLimitDL"
                className="total_dl ng-star-inserted"
              >
                <dt _ngcontent-serverapp-c111> Total Balance</dt>
                <dd _ngcontent-serverapp-c111 id="myCreditLimit">
                  {" "}
                  USD
                  <span _ngcontent-serverapp-c111 className="ng-star-inserted">
                    {" "}
                    {toFixedWithoutRounding(balance?.creditReference)}
                  </span>
                </dd>
              </dl>

              <dl
                _ngcontent-serverapp-c111
                id="totalExposureDL"
                className="total_dl"
              >
                <dt _ngcontent-serverapp-c111>Net Exposure</dt>
                <dd _ngcontent-serverapp-c111 id="totalExposure">
                  {" "}
                  USD
                  <span
                    style={{ marginLeft: "5px" }}
                    _ngcontent-serverapp-c111
                    className="red"
                  >
                    ({toFixedWithoutRounding(balance?.playerExposure)})
                  </span>
                </dd>
              </dl>

              <dl
                _ngcontent-serverapp-c111
                id="balanceDownline"
                className="total_dl"
              >
                <dt _ngcontent-serverapp-c111>Balance</dt>
                <dd _ngcontent-serverapp-c111 id="myCreditLimit">
                  {" "}
                  USD
                  <span _ngcontent-serverapp-c111 className="ng-star-inserted">
                    {" "}
                    {toFixedWithoutRounding(balance?.totalCoins)}
                  </span>
                </dd>
              </dl>
              <dl
                _ngcontent-serverapp-c111
                id="availableBalanceDL"
                className="total_dl"
              >
                <dt _ngcontent-serverapp-c111>Balance in Downline</dt>
                <dd _ngcontent-serverapp-c111 id="totalAvailBal">
                  {" "}
                  USD
                  <span _ngcontent-serverapp-c111 className="ng-star-inserted">
                    {" "}
                    {(!isEmpty(splat)
                      ? getLastSegment(splat)?.userType
                      : initialUserType) == "user"
                      ? toFixedWithoutRounding(balance?.totalAmount)
                      : toFixedWithoutRounding(balance?.totalBalance)}
                  </span>
                </dd>
              </dl>
              <dl
                _ngcontent-serverapp-c111
                id="availableBalanceDL"
                className="total_dl"
              >
                <dt _ngcontent-serverapp-c111>Transferable P/L with Upline</dt>
                <dd _ngcontent-serverapp-c111 id="totalAvailBal">
                  {" "}
                  USD{" "}
                  <span
                    className=""
                    style={{ color: balance.refPL >= 0 ? "red" : "green " }}
                  >
                    ({toFixedWithoutRounding(Math.abs(balance?.refPL))})
                  </span>
                </dd>
              </dl>

              <dl
                _ngcontent-serverapp-c111
                className="total_dl ng-star-inserted"
              >
                <dt _ngcontent-serverapp-c111>Total Users</dt>
                <dd _ngcontent-serverapp-c111>
                  {" "}
                  {toFixedWithoutRounding(results?.totalDocs)}{" "}
                </dd>
              </dl>
            </div>
            <div
              _ngcontent-serverapp-c111
              id="totalBox"
              className="total_box filtertotaldivmob ng-star-inserted"
            >
              <dl
                _ngcontent-serverapp-c111
                id="creditLimitDL"
                className="total_dl_mob"
              >
                <dt _ngcontent-serverapp-c111>Total Player Balance</dt>
                <dd
                  _ngcontent-serverapp-c111
                  id="myCreditLimit"
                  className="push"
                >
                  <strong _ngcontent-serverapp-c111>
                    {" "}
                    {toFixedWithoutRounding(balance?.playerBalance)}
                  </strong>{" "}
                  (USD){" "}
                </dd>
              </dl>

              <div _ngcontent-serverapp-c111 className="text-center">
                <span _ngcontent-serverapp-c111 id="user">
                  <i _ngcontent-serverapp-c111 className="fa fa-chevron-down" />
                </span>
              </div>
            </div>
            {/* user_next_status */}
            <UserList
              results={results}
              handlePageClick={handlePageClick}
              getUsers={getUsers}
              data={user.userType}
              sortBy={search_params?.sortBy}
              orderBy={search_params?.orderBy}
              handleSort={handleSort}
              handlePageChange={handlePageChange}
              handleDrillDown={(row) => handleDrillDown(row)}
              balance={balance}
            />
            <div
              _ngcontent-serverapp-c111
              className="footer_info ng-star-inserted"
            >
              <div _ngcontent-serverapp-c111 className="main_wrap">
                <ul _ngcontent-serverapp-c111 className="action">
                  <li _ngcontent-serverapp-c111 className="f-tab">
                    <span _ngcontent-serverapp-c111 className="timeuserlock">
                      F
                    </span>
                    <p
                      _ngcontent-serverapp-c111
                      className="data_line data-text"
                    >
                      User Locked{" "}
                    </p>
                  </li>

                  <li
                    _ngcontent-serverapp-c111
                    className="lock 111 ng-star-inserted"
                  >
                    <p
                      _ngcontent-serverapp-c111
                      className="data_line data-text1"
                    >
                      Block Market{" "}
                    </p>
                  </li>

                  <li _ngcontent-serverapp-c111 className="p_l">
                    <p
                      _ngcontent-serverapp-c111
                      className="data_line data-text1"
                    >
                      Betting Profit Loss{" "}
                    </p>
                  </li>
                  <li _ngcontent-serverapp-c111 className="betting_history">
                    <p
                      _ngcontent-serverapp-c111
                      className="data_line data-text1"
                    >
                      Betting History{" "}
                    </p>
                  </li>
                  <li _ngcontent-serverapp-c111 className="profile">
                    <p
                      _ngcontent-serverapp-c111
                      className="data_line data-text1"
                    >
                      Profile{" "}
                    </p>
                  </li>
                  <li _ngcontent-serverapp-c111 className="status">
                    <p
                      _ngcontent-serverapp-c111
                      className="data_line data-text1"
                    >
                      Change status{" "}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </app-sub>
        </app-children>
      </div>

      <AddUserModal
        isOpen={show}
        title={`Add ${user?.userType == "agent" ? "User" : startCase(LayerUserText[layer])}`}
        id={user._id}
        slug={user?.userType == "agent" ? "user" : initialUserType}
        submitText="Create"
        onClose={() => setShow(false)}
        refreshUsers={getUsers}
      />
    </app-users-list>
  );
};

export default Home;

const eventOptions = [
  { value: "active", label: "Active" },
  { value: "Locked", label: "Locked" },
  { value: "Suspend", label: "Suspend" },
];

const ADMIN_ROLES = ["super_admin", "sub_owner", "owner"];
